import { render, staticRenderFns } from "./EmployeeLeaves.vue?vue&type=template&id=38d36fb5&scoped=true&"
import script from "./EmployeeLeaves.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeLeaves.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d36fb5",
  null
  
)

export default component.exports